module.exports = __webpack_public_path__ + "img/10_21.9e766aa3.png";